// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "QuestionPage_questionPageQuestionsContainer__FMGtr";
var _3 = "\"../../shared.module.css\"";
export { _1 as "md", _2 as "questionPageQuestionsContainer", _3 as "shared" }
